var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashOn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89107 12.281C2.80757 12.427 2.67982 12.4792 2.50782 12.4377C2.33582 12.3957 2.24982 12.2862 2.24982 12.1092V7.75024H1.03107C0.854067 7.75024 0.700567 7.68499 0.570567 7.55449C0.440067 7.42449 0.374817 7.27099 0.374817 7.09399V0.906494C0.374817 0.729494 0.440067 0.575744 0.570567 0.445244C0.700567 0.315244 0.854067 0.250244 1.03107 0.250244H5.60907C5.84907 0.250244 6.03407 0.349244 6.16407 0.547244C6.29407 0.744744 6.31232 0.952994 6.21882 1.17199L4.12482 5.87524H5.48457C5.73457 5.87524 5.92207 5.98449 6.04707 6.20299C6.17207 6.42199 6.17207 6.64074 6.04707 6.85924L2.89107 12.281Z",
    fill: "#004368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashOn1);
export default __webpack_public_path__ + "static/media/flash_on1.5cd6bad74b65dad3e7d826d402e15973.svg";
export { ForwardRef as ReactComponent };